import { render } from "./DokiMemoElderlys.vue?vue&type=template&id=3e233da0"
import script from "./DokiMemoElderlys.vue?vue&type=script&lang=js"
export * from "./DokiMemoElderlys.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__